module.exports = __webpack_public_path__ + "static/media/edit_constraints_teacher_classrooms.1c55db49.mov";